import angular from 'angular';
import applicationComponent from './application.component';

const PHONE_REGEXP = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
const EMAIL_REGEXP = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/

let applicationModule = angular.module('application', [])

    .component('application', applicationComponent)
    .directive('phone', function() {
      return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
          ctrl.$validators.phone = function(modelValue, viewValue) {
            if (ctrl.$isEmpty(modelValue)) {
              // consider empty models to be valid
              return true;
            }
            if (PHONE_REGEXP.test(viewValue)) {
              // it is valid
              return true;
            }
            // it is invalid
            return false;
          };
        }
      }}).directive('email', function() {
        return {
          require: 'ngModel',
          link: function(scope, elm, attrs, ctrl) {
            ctrl.$validators.email = function(modelValue, viewValue) {
              if (ctrl.$isEmpty(modelValue)) {
                // consider empty models to be valid
                return true;
              }
              if (EMAIL_REGEXP.test(viewValue)) {
                // it is valid
                return true;
              }
              // it is invalid
              return false;
            };
          }
        }})
.name;

let states = [
  {
    name: 'application',
    url: '/application',
    component: 'application',
    title: 'face-application-text01',
    description: 'face-application-text01'
  }
];

export default {name: applicationModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/face/application/application.js